module.exports = __webpack_public_path__ + "assets/img/thumb-Betashares-Video.143f071f.webp";